<template>
  <div class="mt-2">
    <v-progress-linear class="mt-2" indeterminate v-if="loading" color="primary darken-2"></v-progress-linear>
    <data-list :module="module" :filterObj="filterObj" :payload="payload" :model="modelObj" :key="reInit" propId="order_id"></data-list>
    <v-dialog scrollable v-model="dialog" hide-overlay transition="dialog-bottom-transition" persistent fullscreen>
      <v-card>
         <v-card-title class="pa-2" style="background: #036693;color: white">
          <span class="font-weight-bold"> {{ checklistObj.checklist_id  ?  $t('message.checklist.updateChecklist') : $t('message.checklist.addChecklist') }} </span>
          <v-spacer></v-spacer>
          <v-btn color="success" tile  @click="saveUpdateHandler(false)" dark class="mr-1">{{ checklistObj.checklist_id  ? $t('message.common.update') : $t('message.common.save') }}</v-btn>
          <v-btn color="info" tile v-if=" checklistObj.checklist_id"  @click="saveUpdateHandler(true)" dark>{{ $t('message.common.updateAndClose') }}</v-btn>
          <v-btn  class="ml-1" tile color="error" @click="closeDialogHandler()"> {{ $t('message.common.close') }} </v-btn>
        </v-card-title>
        <v-card-text>
         <form-render v-if="dialog" :module="module" :checklistTemplateObj="checklistObj" propId="order_id"
         :defaultMappingValues="defaultMappableValues"></form-render>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      modelObj: {},
      module: this.$route.params.id,
      filterObj: 'ORDER_CHECKLIST_INDEX',
      reInit: 0,
      payload: {},
      dialog: false,
      loading: false,
      checklistObj: {},
      defaultMappableValues: {}
    }
  },
  components: {
    'data-list': () => import('@/components/Checklist/List'),
    'form-render': () => import('@/components/Checklist/Actions')
  },
  computed: {
    ...mapGetters(['getuserDetails'])
  },
  mounted () {
    this.$eventBus.$on('chemicalModel', (data) => {
      this.modelObj = data
      this.reInit++
    })
    this.$eventBus.$on('checklistDialog', (data) => {
      this.dialog = true
      this.checklistObj = data
    })
    this.$eventBus.$on('updatechecklistDialog', (data) => {
      this.dialog = true
      this.checklistObj = data
    })
    this.$eventBus.$on('closeChecklistDialog', () => {
      this.dialog = false
      this.$eventBus.$emit('clearChecklist')
    })
    this.$eventBus.$on('setChecklistId', (data, obj) => {
      this.checklistObj = data
    })
    this.$eventBus.$on('showLoading', () => {
      this.loading = true
    })
    this.$eventBus.$on('hideLoading', () => {
      this.loading = false
    })
    this.getOrderChecklistDefaultMappingValues(this.$route.params.order_id)
  },
  methods: {
    closeDialogHandler () {
      this.dialog = false
      this.$eventBus.$emit('clearChecklist')
    },
    saveUpdateHandler (type) {
      this.$root.$emit('saveUpdate', type)
    },
    getOrderChecklistDefaultMappingValues (orderId) {
      // Api that will return values of order object
      // it is hard-coded as module=2 since checklist is used only on Order!
      this.$_executeApi('get', `documenttemplates/get_module_field_values?module=2&record_id=${orderId}`)
        .then(({ data }) => {
          this.defaultMappableValues = data || {}
        })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('chemicalModel')
    this.$eventBus.$off('checklistDialog')
    this.$eventBus.$off('updatechecklistDialog')
    this.$eventBus.$off('closeChecklistDialog')
    this.$eventBus.$off('setChecklistId')
    this.$eventBus.$off('hideLoading')
    this.$eventBus.$off('showLoading')
  }
}
</script>

<style>
</style>
